// extracted by mini-css-extract-plugin
module.exports = {"container":"user-nav_container__1nh4K","borderBottom":"user-nav_borderBottom__3mP4E"};